module.exports = __webpack_public_path__ + "img/P150T_weapon_94.d4764f08.png";